import addIndex from "ramda/es/addIndex";
import compose from "ramda/es/compose";
import concat from "ramda/es/concat";
import equals from "ramda/es/equals";
import inc from "ramda/es/inc";
import map from "ramda/es/map";
import prop from "ramda/es/prop";
export const typeP = prop('type');
export const mapIndexed = addIndex(map);
export const isActionType = (actionType)=>compose(equals(actionType), typeP);
export const showActionTypeWithPayloadOf = (payloadKey)=>(action)=>payloadKey ? `${action.type}: ${action.payload[payloadKey]}` : `${action.type}: ${action.payload}`;
export const concatTime = (time)=>concat(`@ ${time}: `);
export const withTime = (time, formatter)=>compose(concatTime(time), formatter);
export const formatActionToListItem = (value, index)=>concat(`\n ${inc(index)}. `, value);
export const createActionList = (actionType, list)=>concat(list, `${actionType}`);
